import { useState } from "react";
import { Input } from "@/components/ui/input";
import { describeRecurrence } from "./calUtils";

export const CalEventList = ({ events, calendar, onOpen }) => {
  const [q, setQ] = useState("");
  const shown = events.filter((e) => e.title.toLowerCase().includes(q.toLowerCase()));
  return (
    <section data-testid="cal-event-list">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-3">
        <div className="lf-label">Recurring events · {events.length}</div>
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filter…" className="h-8 w-48" data-testid="cal-event-filter-input" />
      </div>
      <div className="grid gap-1.5 sm:grid-cols-2 lg:grid-cols-3">
        {shown.map((e) => (
          <button key={e.id} type="button" onClick={() => onOpen(e)} data-testid={`cal-event-row-${e.id}`}
            className="flex items-start gap-2.5 rounded-md border border-[#2D3442] px-3 py-2 text-left transition-colors hover:border-[#F59E0B]/50">
            <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full" style={{ background: e.color }} />
            <span className="min-w-0">
              <span className="block truncate text-sm text-[#F3EBDD]">{e.title}{e.duration > 1 ? ` · ${e.duration} days` : ""}</span>
              <span className="block truncate text-xs text-[#A8A090]">{describeRecurrence(e.recurrence, calendar)}</span>
            </span>
          </button>
        ))}
      </div>
    </section>
  );
};
